<template>
  <div class="upload-work">
    <div class="upload-content">
      <el-form
        ref="uploadForm"
        :model="uploadForm"
        :rules="rules"
        label-width="120px"
        size="mini">
        <el-form-item label="作业附件" prop="files">
          <div class="file-list" v-if="fileList.length">
            <div v-for="(item, index) in fileList" :key="index" class="file-item">
              <a :href="item" target="_blank">
                <i class="el-icon-document text-icon"></i>
                <span class="file-name">{{ getFileName(item) }}</span>
              </a>
              <i class="el-icon-close" @click="handleRemove(item)"></i>
            </div>
          </div>
          <el-upload
            v-if="fileList.length < 1"
            class="file-uploader"
            :accept="'.pdf'"
            :show-file-list="false"
            :on-success="handleUploadSuccess"
            :action="uploadAction"
            name="uploadFile"
            :before-upload="beforeUpload">
            <el-button size="mini" type="primary">选择文件</el-button>
          </el-upload>
          <div class="upload-tip">
            只能上传PDF文件,单个文件不超过10MB
          </div>
        </el-form-item>
        <el-form-item label="补充说明" prop="content">
          <el-input
            v-model="uploadForm.content"
            type="textarea"
            :rows="4"
            placeholder="请输入补充说明（选填，最多200字符）"
            maxlength="200"
            show-word-limit>
          </el-input>
        </el-form-item>
      </el-form>
      <div class="upload-footer">
        <el-button @click="handleClose">取消</el-button>
        <el-button
          type="primary"
          :loading="submitting"
          @click="handleSubmit">
          提交作业
        </el-button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'UploadWork',
  props: {
    rowData: {
      type: Object,
      required: true
    },
    extraParams: Object,
    visible: Boolean
  },
  data () {
    return {
      submitting: false,
      uploadForm: {
        files: [],
        content: ''
      },
      fileList: [],
      originalFileNames: {},
      rules: {
        files: [
          { required: true, message: '请上传作业附件', trigger: 'change' }
        ],
        content: [
          { max: 200, message: '补充说明不能超过200个字符', trigger: 'blur' }
        ]
      }
    }
  },
  computed: {
    uploadAction () {
      return '/workspace/manager/teaching/schedule/upload/work'
    }
  },
  mounted () {
    console.log(this.$refs)
    this.initParams()
  },
  methods: {
    initParams () {
      // 从路由参数获取必要参数
      this.workId = this.extraParams.workId
      this.postId = this.rowData.id
      console.log('获取到的参数:', this.rowData, this.extraParams, this.visible)
    },
    beforeUpload (file) {
      if (this.fileList.length >= 1) {
        this.$message.error('最多只能上传1个文件')
        return false
      }
      let filename = file.name
      let index = filename.lastIndexOf('.')
      if (index > 0) {
        let suffix = filename.substring(index).toLowerCase()
        if (suffix !== '.pdf') {
          this.$message.error('只能上传PDF文件')
          return false
        }
      } else {
        this.$message.error('上传的文件格式不合法')
        return false
      }
      const isLt10M = file.size / 1024 / 1024 < 10
      if (!isLt10M) {
        this.$message.error('上传文件大小不能超过 10MB!')
      }
      // 保存原始文件名
      this.currentFileName = filename
      return isLt10M
    },
    handleUploadSuccess (response) {
      if (response.errorCode === 0) {
        this.fileList.push(response.uploadLink)
        // 保存原始文件名与URL的映射关系
        this.originalFileNames[response.uploadLink] = this.currentFileName
        this.uploadForm.files = [...this.fileList]
        this.$message.success('文件上传成功')
      } else {
        this.$message.error(response.message)
      }
    },
    handleRemove (file) {
      for (let i = 0; i < this.fileList.length; i++) {
        if (this.fileList[i] === file) {
          this.fileList.splice(i, 1)
          // 同时删除对应的原始文件名映射
          delete this.originalFileNames[file]
        }
      }
      this.uploadForm.files = [...this.fileList]
    },
    getFileName (url) {
      // 优先使用保存的原始文件名
      if (this.originalFileNames[url]) {
        return this.originalFileNames[url]
      }
      // 如果没有保存的原始文件名，则从URL中提取
      const parts = url.split('/')
      return parts[parts.length - 1]
    },
    handleExceed (files, fileList) {
      this.$message.warning('最多只能上传1个文件')
    },
    handleSubmit () {
      this.$refs.uploadForm.validate(valid => {
        if (valid) {
          if (this.uploadForm.files.length === 0) {
            this.$message.error('请先上传作业附件')
            return
          }
          this.submitWork()
        }
      })
    },
    submitWork () {
      this.submitting = true
      const params = {
        workId: this.workId,
        postId: this.postId,
        files: this.uploadForm.files,
        content: this.uploadForm.content || ''
      }
      console.log('提交参数:', params)
      this.$ajax({
        url: '/workspace/manager/teaching/schedule/work/uploadWork',
        method: 'post',
        data: this.$qs.stringify(params, {
          arrayFormat: 'repeat'
        })
      }).then(response => {
        if (response.data) {
          if (response.data.responseCode === 'SUCCESS') {
            this.$message.success('作业提交成功')
            this.handleClose()
            this.$emit('success')
          } else {
            this.$message.warning(response.data.message)
          }
        }
      }).catch(() => {
        this.$message.error('请求发送失败，请稍后重试')
      }).finally(() => {
        this.submitting = false
      })
    },
    handleClose () {
      this.$router.go(-1)
    }
  }
}
</script>

<style lang="scss" scoped>
.upload-work {
  height: 100%;
  overflow: auto;
  overflow-x: hidden;
  .upload-content {
    padding: 20px;
    max-width: 800px;
    margin: 0 auto;
  }
  .upload-footer {
    text-align: center;
    margin-top: 30px;
  }
  .file-list {
    margin-bottom: 10px;
    .file-item {
      display: flex;
      align-items: center;
      padding: 8px;
      border: 1px solid #d9d9d9;
      border-radius: 4px;
      margin-bottom: 8px;
      background-color: #fafafa;
      .text-icon {
        margin-right: 8px;
        color: #409EFF;
      }
      .file-name {
        flex: 1;
        color: #333;
        font-size: 12px;
      }
      .el-icon-close {
        color: #f56c6c;
        cursor: pointer;
        margin-left: 8px;
        &:hover {
          color: #f56c6c;
        }
      }
    }
  }
  .file-uploader {
    margin-bottom: 10px;
  }
  .upload-tip {
    color: #909399;
    font-size: 12px;
    margin-top: 7px;
  }
}
</style>
